import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { StageIncludeItemsMergeData } from './stage.include.items.merge.data';

@MergeSchema({
    entity: ActivityEntityName.JobStages
})
export class JobStagesMergeData {

    @MergeField({
        arraySchemaName: 'StageIncludeItemsMergeDataSchema'
    })
    stages: StageIncludeItemsMergeData[] = [];

    @MergeField()
    itemCount: number;
}

export const JobStagesMergeDataSchema = getSchema(JobStagesMergeData);